import { useMemo } from "react";
import ActionButtons from "../common/actionButtons";
import { toast } from "react-toastify";
import { formatQuantity, productDisplayState, productQuantityState } from "../../function/store";

const GroupItem = ({
  item,
  context,
  setContext,
  changeTab,
  openModal,
  closeModal,
  removeGroup,
  removeProduct,
  clickImages,
  toggleModal,
  changeStatus,
}) => {
  return (
    <div className={`groupItem`}>
      <div className="menu">
        <span className="name">{item.name}</span>
        <ActionButtons
          context={context}
          setContext={setContext}
          item={item}
          highlight={true}
          changeStatus={(type, item) => updateOption(type, item)}
          buttons={[
            { label: "수정", onClick: () => changeTab(1, item) },
            {
              label: "삭제",
              onClick: () =>
                openModal({
                  type: "confirmation",
                  title: "메뉴 그룹 삭제",
                  message: [`${item.name} 메뉴 그룹을 삭제하시겠습니까?`],
                  handleConfirm: () => removeGroup(item.id),
                }),
            },
          ]}
        />
      </div>
      <div className="products">
        {item.products.map((product) => {
          const { status, ...filteredProduct } = product;

          return (
            <div key={product.id} className={productQuantityState(product)?.status}>
              <div className="productInfo">
                <img
                  src={imgHandler(product.media)}
                  alt={product.name}
                  onClick={() => clickImages(product.media, 0)}
                  onError={(e) => (e.target.src = "/img/icon_function_4.png")}
                />
                <div>
                  <div className="tags">
                    <span className={product?.useDisplay ? "active" : "inactive"}>
                      {productDisplayState(product)}
                    </span>
                  </div>
                  <span className="name">{product.name}</span>
                  {product.shortDescription && (
                    <span className="shortDescription">{product.shortDescription}</span>
                  )}
                  <p>
                    <span className="quantity">재고 {formatQuantity(product.quantity)}</span>
                    <span className="price">
                      {product.price ? `${formatNumber(product.price)}원` : "가격미정"}
                    </span>
                  </p>
                </div>
              </div>
              <ActionButtons
                context={context}
                setContext={setContext}
                parentId={item.id}
                item={product}
                changeStatus={changeStatus}
                buttons={[
                  {
                    label: "수정",
                    onClick: () => {
                      toggleModal("product", {
                        ...item,
                        products: item.products.map((prd) =>
                          prd.id === filteredProduct.id ? { ...prd, target: true } : prd,
                        ),
                      });
                    },
                  },
                  {
                    label: "삭제",
                    onClick: () => {
                      if (item.products.length === 1) {
                        toast.error("메뉴 그룹에는 최소 1개의 상품이 필요합니다.");
                        return;
                      }
                      openModal({
                        type: "confirmation",
                        title: "메뉴 삭제",
                        message: [
                          `${item.name}에서 ${chooseParticle(
                            product.name,
                            "을를",
                          )} 삭제하시겠습니까?`,
                        ],
                        handleConfirm: () => removeProduct(item, product.id),
                      });
                    },
                  },
                ]}
              />
            </div>
          );
        })}
        <button className="add" onClick={() => toggleModal("product", item)}>
          상품추가
        </button>
      </div>
    </div>
  );
};

export default GroupItem;
